import { jsx as _jsx } from "react/jsx-runtime";
import { usePaymentMethodUpdate } from "./Shared/hooks/PaymentMethodUpdate/usePaymentMethodUpdate";
import { ConfirmationDialog } from "../../Shared/components/ConfirmationDialog";
const RemoveCardModal = ({ open, onClose, selectedCard }) => {
    const { deactivatePaymentMethod } = usePaymentMethodUpdate();
    const confirmRemovePaymentMethod = () => {
        if (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.id) {
            deactivatePaymentMethod(selectedCard.id);
        }
        onClose();
    };
    return (_jsx(ConfirmationDialog, { isOpen: open, dialogTitle: "Are you sure you'd like to remove this card?", cancelButtonText: "Cancel", confirmButtonText: "Confirm", onCancelButtonClick: () => onClose(), onConfirmButtonClick: confirmRemovePaymentMethod }));
};
export default RemoveCardModal;
